import reducers from './Reducers';
import {loadUser} from "redux-oidc";
import userManager from './UserManager';
import {dispatchUpdateData, PAGES} from '../common/Shared';
import {createStore} from "redux";


const reduxStore = createStore((state, action) => {
		// === reducers ===
		let reducer = false;

		// is reducer valid?
		if (action.type in reducers) {
			reducer = reducers[action.type];
		}

		// ignore redux/react "system" reducers
		if (!reducer && action.type.indexOf('@@') !== 0 && action.type.indexOf('redux-oidc') !== 0) {
			console.error('unknown reducer action:', action.type, action);
		}

		// DO IT!
		return reducer ? reducer(state, action) : (state || null);
	}, {
		oidc: {
		},
		app: {
			offer: undefined,
            showEdit: false,
			accepted: false,
			rejected: false,
		},
		account: {
			roles: undefined,
		},
		dataList: {
			careerSchedule: [],
			agency: [],
			workLocation: [],
            rejectionReason: []
		},
		messages: []
	}
	// for chrome redux plugin
	, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);
// it doesn't auto-populate reduxstore? the example does, why doesn't this?
loadUser(reduxStore, userManager).then(user => dispatchUpdateData({path: 'oidc', field: 'user', value: user}));

export default reduxStore;
